// @ts-ignore
import featureFlagYaml from './feature-flag.yml'
import Auth from '../../lib/commons/auth'

type Flag = 'ON' | 'OFF' | 'PARTIAL'
type FeatureFlag = {
  flag: Flag
  tenantWhiteList: string[]
}

const parseFlag = (src: string): Flag => {
  const upperSrc = src.toUpperCase()
  if (upperSrc === 'ON') {
    return 'ON'
  }
  if (upperSrc === 'OFF') {
    return 'OFF'
  }
  if (upperSrc === 'PARTIAL') {
    return 'PARTIAL'
  }
  return 'OFF'
}

const parseFeatureFlag = (src: any): FeatureFlag => {
  const flag = parseFlag(src.flag)
  const tenantWhiteList = src['tenant-white-list'] || []
  return {
    flag,
    tenantWhiteList,
  }
}

class FeatureFlagService {
  private flags: Record<string, FeatureFlag> = {}
  constructor() {
    const env = process.env.FLAGXS_ENV || 'development'
    Object.entries(featureFlagYaml).forEach(([key, value]: [string, any]) => {
      const v = value[env]
      this.flags[key] = parseFeatureFlag(v)
    })
  }

  public isEnabled(feature: string): boolean {
    const flag = this.flags[feature]
    if (!flag) {
      return false
    }
    if (flag.flag === 'ON') {
      return true
    }
    if (flag.flag === 'OFF') {
      return false
    }
    if (flag.flag === 'PARTIAL') {
      const tenantUuid = Auth.getCurrentTenant()?.tenantUuid
      if (!tenantUuid) {
        return false
      }
      return flag.tenantWhiteList.includes(tenantUuid)
    }
    return false
  }
}

export const featureFlagService = new FeatureFlagService()
